var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social, Media/Instagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.496 3.27026H16.505C18.987 3.27026 21 5.28226 21 7.76626V16.7753C21 19.2573 18.988 21.2703 16.504 21.2703H7.496C5.013 21.2703 3 19.2583 3 16.7743V7.76626C3 5.28326 5.012 3.27026 7.496 3.27026V3.27026Z",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M16.949 6.9833C16.763 6.9843 16.612 7.1353 16.612 7.3213C16.612 7.5073 16.764 7.6583 16.95 7.6583C17.136 7.6583 17.287 7.5073 17.287 7.3213C17.288 7.1343 17.136 6.9833 16.949 6.9833",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M14.5455 9.72458C15.9514 11.1305 15.9514 13.4099 14.5455 14.8158C13.1396 16.2216 10.8602 16.2216 9.45432 14.8158C8.04843 13.4099 8.04843 11.1305 9.45432 9.72458C10.8602 8.31869 13.1396 8.31869 14.5455 9.72458",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.153e9897f514477cc6ddf6e22eb5d09d.svg";
export { ForwardRef as ReactComponent };